import { connect } from 'react-redux';
import challengeActions from '../../../../store/actions/challenge.action';
import TercerFactor from './TercerFactor';
import appModalActions from '../../../../store/actions/appModal.action';

const mapStateToProps = state => ({
    isLoading: state.challenge.loading,
    challengeResponse: state.challenge.challengeResponse,
    errorInput: state.challenge.errorInput,
    errorMessage: state.challenge.errorMessage,
    isExpired: state.challenge.isExpired,
    isBloqued: state.challenge.isBloqued,
    isSmsRequestValid: state.challenge.isSmsRequestValid
});

const mapDispatchToProps = dispatch => {
    return {

        changeSMSChallengeResponse: smscode => {
            dispatch(challengeActions.changeSMSChallengeResponse(smscode));
        },

        getSMSChallenge: () => {
            dispatch(challengeActions.getSMSChallenge());
        },

        validateSMSChallenge: smscode => {
            dispatch(challengeActions.validateSMSChallenge(smscode));
        },

        removeError: () => {
            dispatch(challengeActions.removeError());
        },

        changeErrorMessage: (message) => {
            dispatch(challengeActions.changeErrorMessage(message));
        },
        closeChallenge: () => {
            dispatch(challengeActions.closeChallenge());
        },
        openErrorModal: (message) => {
            dispatch(appModalActions.openErrorModal(message));
        },
    };  
  };

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TercerFactor);